export default "__VITE_ASSET__Dwzh57dD__"